import { render, staticRenderFns } from "./SettingSite.vue?vue&type=template&id=49695234&scoped=true&"
import script from "./SettingSite.vue?vue&type=script&lang=js&"
export * from "./SettingSite.vue?vue&type=script&lang=js&"
import style0 from "./SettingSite.vue?vue&type=style&index=0&id=49695234&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49695234",
  null
  
)

export default component.exports